/**
 * Shared price-copy helper for public event UI (CTA cards, modals, sidebars).
 *
 * Safety: if price_ore is null/undefined the price line is omitted (primary = null)
 * so callers never silently show "Gratis" for events with unknown pricing.
 */
export function getPriceCopy(event: { is_free: boolean; price_ore: number | null | undefined }) {
  // Explicitly free
  if (Boolean(event.is_free)) {
    return { primary: 'Gratis', secondary: null };
  }
  // Price known and zero → free
  if (event.price_ore != null && event.price_ore <= 0) {
    return { primary: 'Gratis', secondary: null };
  }
  // Price known and positive → formatted
  if (event.price_ore != null && event.price_ore > 0) {
    const formatted = `${(event.price_ore / 100).toLocaleString('sv-SE')} kr per person`;
    return { primary: formatted, secondary: 'Betalning sker på plats.' };
  }
  // Price unknown → omit
  return { primary: null, secondary: null };
}
